__turbopack_context__.v({
  "activeCount": "PriceSliderFilter-module-scss-module__VblDoa__activeCount",
  "chevron": "PriceSliderFilter-module-scss-module__VblDoa__chevron",
  "content": "PriceSliderFilter-module-scss-module__VblDoa__content",
  "expanded": "PriceSliderFilter-module-scss-module__VblDoa__expanded",
  "header": "PriceSliderFilter-module-scss-module__VblDoa__header",
  "name": "PriceSliderFilter-module-scss-module__VblDoa__name",
  "priceSlider": "PriceSliderFilter-module-scss-module__VblDoa__priceSlider",
  "rangeLabels": "PriceSliderFilter-module-scss-module__VblDoa__rangeLabels",
  "slider": "PriceSliderFilter-module-scss-module__VblDoa__slider",
  "sliderContainer": "PriceSliderFilter-module-scss-module__VblDoa__sliderContainer",
  "thumb": "PriceSliderFilter-module-scss-module__VblDoa__thumb",
  "thumbLabel": "PriceSliderFilter-module-scss-module__VblDoa__thumbLabel",
  "track": "PriceSliderFilter-module-scss-module__VblDoa__track",
});
